/**
 * The client's packages (abonements) in the widget cabinet
 * (boona: docs/codebase/abonements/README.md A4).
 */
export type PackageLine = { title: string; is_category: boolean; unlimited: boolean; left: number | null; total: number | null };

export type ClientPackage = {
    id: number;
    number: string;
    title: string;
    status: "active" | "expired" | "used_up" | string;
    issued_at: string | null;
    expires_at: string | null;
    pool: boolean;
    left: number | null;     // null = unlimited
    total: number | null;
    used: number | null;
    lines: PackageLine[];
};

/** Active first (soonest to expire first), then used up, then expired. */
export function sortPackages(list: ClientPackage[]): ClientPackage[] {
    const rank = (s: string) => (s === "active" ? 0 : s === "used_up" ? 1 : s === "expired" ? 2 : 1);
    return [...(list ?? [])].sort((a, b) =>
        rank(a.status) - rank(b.status) || (a.expires_at ?? "9").localeCompare(b.expires_at ?? "9"));
}

/** What the card says a package covers: its lines' titles. */
export function coversText(p: ClientPackage): string {
    return (p.lines ?? []).map((l) => l.title).filter(Boolean).join(", ");
}
